import React from "react";
import { Board } from "../../../lib/api/boards";

interface EditableBoardNameProps {
  isEditingName: boolean;
  boardName: string;
  board: Board | undefined;
  inputRef: React.RefObject<HTMLInputElement>;
  isUpdating: boolean;
  onNameClick: () => void;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onNameKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onNameBlur: () => void;
}

export const EditableBoardName: React.FC<EditableBoardNameProps> = ({
  isEditingName,
  boardName,
  board,
  inputRef,
  isUpdating,
  onNameClick,
  onNameChange,
  onNameKeyDown,
  onNameBlur,
}) => {
  if (isEditingName) {
    return (
      <input
        ref={inputRef}
        type="text"
        name="board-name-field"
        autoComplete="off"
        data-1p-ignore
        data-lpignore="true"
        data-bwignore="true"
        data-form-type="other"
        value={boardName}
        onChange={onNameChange}
        onKeyDown={onNameKeyDown}
        onBlur={onNameBlur}
        className="w-full px-2 py-1 text-xs font-semibold text-text-primary bg-white border border-accent-primary rounded focus:outline-none focus:ring-1 focus:ring-accent-primary"
        disabled={isUpdating}
      />
    );
  }

  return (
    <div
      onClick={onNameClick}
      className="px-0 py-1 text-xs font-semibold text-text-primary hover:bg-neutral-100 rounded cursor-pointer transition-colors"
    >
      {boardName || board?.name || "Loading..."}
    </div>
  );
};
